import styled from 'styled-components';
import { palette } from '../../theme/colors';

export const SBanner = styled.section`
  display: flex;
  gap: 0.75rem;
  align-items: center;
  width: 100%;
  padding: 1rem;
  background-color: ${palette.charcoal};
  border-radius: 1rem;
  color: ${palette.white};
`;

export const SDescription = styled.p`
  font-size: 0.875rem;
  line-height: 1.45em;
  margin: 0;
  padding: 0;
`;
